import { render, staticRenderFns } from "./tabComs.vue?vue&type=template&id=5ae01101&"
import script from "./tabComs.vue?vue&type=script&lang=js&"
export * from "./tabComs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports